<div class="modal-header modal-h">
  <h5 class="modal-title" id="addAddressLabel" *ngIf="actionType === 'edit'">
    {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.EDIT_TITLE' | translate }}
  </h5>
  <h5 class="modal-title" id="addAddressLabel" *ngIf="actionType !== 'edit'">
    {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.ADD_TITLE' | translate }}
  </h5>
  <button
    type="button"
    class="btn-close"
    (click)="closeBtnClick()"
    aria-label="Close"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-b">
  <form [formGroup]="addBeneficiaryForm" (ngSubmit)="addBeneficiary()">
    <div class="form-group">
      <label for="kinship" class="">{{
        'BENEFIT_SUMMARY.ADD_EDIT_FORM.KINSHIP' | translate
      }}</label>

      <ng-select [searchable]="false" labelForId="kinship"
      [placeholder]="'BENEFIT_SUMMARY.ADD_EDIT_FORM.CHOOSE_KINSHIP' | translate"
      [appendTo]="'body'"
      showIconIfScrollbar
      formControlName="kinship"
      id="kinship">
        <ng-option class="custom-option"  *ngFor="let dk of degreeKinship" [value]="dk.id">
          {{ dk.name }}
        </ng-option>
      </ng-select>
      <div
        *ngIf="f.kinship.errors && addBeneficiaryFormSubmitted"
        class="invalid-feedback"
        [ngClass]="{
          'd-block': f.kinship.errors && addBeneficiaryFormSubmitted
        }"
      >
        <div *ngIf="f.kinship.errors.required">
          {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.KINSHIP_REQUIRED' | translate }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="name" class="">{{
        'BENEFIT_SUMMARY.ADD_EDIT_FORM.NAME' | translate
      }}</label>
      <div>
        <input
          type="text"
          class="form-control"
          formControlName="name"
          id="name"
          placeholder="{{
            'BENEFIT_SUMMARY.ADD_EDIT_FORM.PLACEHOLDER.NAME' | translate
          }}"
        />
        <div
          *ngIf="f.name.errors && f.name.touched"
          class="invalid-feedback"
          [ngClass]="{
            'd-block': f.name.errors && addBeneficiaryFormSubmitted
          }"
        >
          <div *ngIf="f.name.errors.required">
            {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.NAME_REQUIRED' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="cnp" class="">CNP</label>
      <div class="masked-field">
        <app-masked-input
          [masked]="!showCnp"
          formControlName="cnp"
          id="cnp"
          placeholder="{{
            'BENEFIT_SUMMARY.ADD_EDIT_FORM.PLACEHOLDER.CNP' | translate
          }}"
        ></app-masked-input>
        <span class="mask-toggle" (click)="showCnp = !showCnp">
          <i class="feather" [ngClass]="showCnp ? 'icon-eye-off' : 'icon-eye'"></i>
        </span>
        <div
          *ngIf="f.cnp.errors && f.cnp.touched"
          class="invalid-feedback"
          [ngClass]="{
            'd-block': f.cnp.errors && addBeneficiaryFormSubmitted
          }"
        >
          <div *ngIf="f.cnp.errors.required">
            {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.CNP_REQUIRED' | translate }}
          </div>
          <div *ngIf="f.cnp.errors.pattern">
            {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.CNP_VALID' | translate }}
          </div>
          <div *ngIf="f.cnp.errors.errors">
            {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.CNP_INVALID' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="city" class="">{{
        'BENEFIT_SUMMARY.ADD_EDIT_FORM.CITY' | translate
      }}</label>
      <div>
        <input
          type="text"
          class="form-control"
          formControlName="city"
          id="city"
          placeholder="{{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.CITY' | translate }}"
        />
        <div
          *ngIf="f.city.errors && f.city.touched"
          class="invalid-feedback"
          [ngClass]="{
            'd-block': f.city.errors && addBeneficiaryFormSubmitted
          }"
        >
          <div *ngIf="f.city.errors.required">
            {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.CITY_REQUIRED' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="phone" class="">{{
        'BENEFIT_SUMMARY.ADD_EDIT_FORM.PHONE_NUMBER' | translate
      }}</label>
      <div class="masked-field">
        <app-masked-input
          [masked]="!showPhone"
          inputMode="numeric"
          formControlName="phone"
          id="phone"
          placeholder="{{
            'BENEFIT_SUMMARY.ADD_EDIT_FORM.PLACEHOLDER.PHONE' | translate
          }}"
        ></app-masked-input>
        <span class="mask-toggle" (click)="showPhone = !showPhone">
          <i class="feather" [ngClass]="showPhone ? 'icon-eye-off' : 'icon-eye'"></i>
        </span>
        <div
          *ngIf="f.phone.errors && f.phone.touched"
          class="invalid-feedback"
          [ngClass]="{
            'd-block': f.phone.errors && addBeneficiaryFormSubmitted
          }"
        >
          <div *ngIf="f.phone.errors.required">
            {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.PHONE_REQUIRED' | translate }}
          </div>
          <div *ngIf="f.phone.errors.pattern">
            {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.PHONE_VALID' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="fs-12">
      {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.PHONE_INFO' | translate }}
    </div>

    <div class="form-group">
      <label for="email" class="">Email</label>
      <div class="masked-field">
        <app-masked-input
          [masked]="!showEmail"
          formControlName="email"
          id="email"
          placeholder="{{
            'BENEFIT_SUMMARY.ADD_EDIT_FORM.PLACEHOLDER.EMAIL' | translate
          }}"
        ></app-masked-input>
        <span class="mask-toggle" (click)="showEmail = !showEmail">
          <i class="feather" [ngClass]="showEmail ? 'icon-eye-off' : 'icon-eye'"></i>
        </span>
        <div
          *ngIf="f.email.errors && f.email.touched"
          class="invalid-feedback"
          [ngClass]="{
            'd-block': f.email.errors && addBeneficiaryFormSubmitted
          }"
        >
          <div *ngIf="f.email.errors.required">
            {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.EMAIL_REQUIRED' | translate }}
          </div>
          <div *ngIf="f.email.errors.email || f.email.errors.pattern">
            {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.EMAIL_VALID' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="fs-12">
      {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.EMAIL_INFO' | translate }}
    </div>

    <div class="form-group">
      <div class="custom-control custom-checkbox">
        <input
          class="custom-control-input"
          type="checkbox"
          formControlName="terms"
          id="register-privacy-policy"
        />
        <label class="custom-control-label" for="register-privacy-policy">
          {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.ACCEPTED_TERMS' | translate }}
          <a target="_blank" href="{{ tosDocumentUrl }}" class="c-company">{{
            'BENEFIT_SUMMARY.TERMS2' | translate
          }}</a>
        </label>
        <div
          *ngIf="f.terms?.errors?.required && addBeneficiaryFormSubmitted"
          class="invalid-feedback"
        >
          {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.TERMS_REQUIRED' | translate }}
        </div>
      </div>
    </div>

    <div class="modal-f space-between">
      <button
        type="submit"
        class="btn btn-primary"
        *ngIf="actionType === 'edit'"
      >
        {{ 'ADD_EDIT_FORM.EDIT' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        *ngIf="actionType !== 'edit'"
      >
        <span class="ficon feather icon-arrow-right"></span>
        {{ 'BENEFIT_SUMMARY.ADD_EDIT_FORM.ADD' | translate }}
      </button>
      <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
        {{ 'ADD_EDIT_FORM.CLOSE' | translate }}
      </button>
    </div>
  </form>
</div>
